import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import SelectField from "@FormElements/SelectField";
import FormContext from "formContext";

function SalarySelectField({intl, settings, ...rest}) {
  const {additionalData: {masterLists}} = useContext(FormContext);

  settings.options = [{
    value: '',
    label: intl.formatMessage({id: 'Register.Form.Salary.Field.EmptyOption'})
  }];

  if (masterLists && masterLists.hasOwnProperty('PermSalaryRange')) {
    const {PermSalaryRange} = masterLists;
    if (PermSalaryRange.length) {
      PermSalaryRange.forEach(salary => {
        if (salary.ParentCode === 'MonthlySalary') {
          settings.options.push({
            value: salary.Code,
            label: salary.ListValue
          })
        }
      });
    }
  }
  return (
    <SelectField
      settings={settings}
      {...rest}
    />
  )

}

export default injectIntl(SalarySelectField);
